//import SearchBtn from "@/pcomponents/common/crud/list/search/btn/search_btn";
import search_ico2 from "@/img/ico/search2.png";
function SearchBtn(props: any) {
  let myProps = {
    on_click: () => { },
    class_name: "btn-l btn-yellowish2",
    btn_style: {},
    img_style: { maxHeight: 25, minWidth: 20 },
    ...props
  };
  let btn_style:any = {
    ...myProps.btn_style
  };
  let img_style:any={
    maxHeight: 25,
    minWidth: 20,
    ...myProps.img_style
  };

  return (
    <button className="btn btn-yellowish2" onClick={() => { myProps.on_click(); }} style={btn_style}>
      <img src={search_ico2} style={img_style} />
    </button>
  );
};
export default SearchBtn;